import React from "react";
import { Card } from "@themesberg/react-bootstrap";

export default function DashboardSection({
  title,
  subtitle,
  action,
  children,
  className = "",
  bodyClassName = "p-4",
  noPadding = false,
  uniform = false,
}) {
  return (
    <Card
      className={`dashboard-section border-0 ${uniform ? "dashboard-section--uniform" : ""} ${className}`}
    >
      {(title || action) && (
        <Card.Header className="dashboard-section-header bg-transparent border-0 pt-4 px-4 pb-0">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
            <div>
              {title && <h5 className="dashboard-section-title mb-1">{title}</h5>}
              {subtitle && <p className="dashboard-section-subtitle mb-0">{subtitle}</p>}
            </div>
            {action && <div className="dashboard-section-action">{action}</div>}
          </div>
        </Card.Header>
      )}
      <Card.Body className={`${noPadding ? "p-0" : bodyClassName}${uniform ? " dashboard-section-body--uniform" : ""}`}>
        {children}
      </Card.Body>
    </Card>
  );
}
